export default [{
        path: '/',
        component: () => import('@/views/about/Index.vue'),
        children: [{

                path: '/',
                name: 'about.about',
                meta: {
                    title: '关于翡翠王朝'
                },
                component: () => import('@/views/about/About.vue'),
            },
            {

                path: '/about/us',
                meta: {
                    title: '关于我们'
                },
                component: () => import('@/views/about/Us.vue'),
                children: [{

                        path: '/',
                        name: 'about.us',
                        meta: {
                            title: '公司简介',
                            tab: 0,
                            share_description:"打造数字经济时代最强大的珠宝玉石公司，在客户满意度、产业服务能力、伙伴成就感等方面追求极致"
                        },
                        component: () => import('@/views/about/components/us/BriefIntroduction.vue'),
                    },
                    {

                        path: '/about/us/founder',
                        name: 'about.founder',
                        meta: {
                            title: '创始人介绍',
                            tab: 1,
                            share_description:"打造数字经济时代最强大的珠宝玉石公司，在客户满意度、产业服务能力、伙伴成就感等方面追求极致"
                        },
                        component: () => import('@/views/about/components/us/FounderIntroduction.vue'),
                    },
                    {

                        path: '/about/us/culture',
                        name: 'about.culture',
                        meta: {
                            title: '企业文化',
                            tab: 2,
                            share_description:"打造数字经济时代最强大的珠宝玉石公司，在客户满意度、产业服务能力、伙伴成就感等方面追求极致"
                        },
                        component: () => import('@/views/about/components/us/CorporateCulture.vue'),
                    },
                    {

                        path: '/about/us/honour',
                        name: 'about.honour',
                        meta: {
                            title: '所获荣誉',
                            tab: 3,
                            share_description:"打造数字经济时代最强大的珠宝玉石公司，在客户满意度、产业服务能力、伙伴成就感等方面追求极致"
                        },
                        component: () => import('@/views/about/components/us/Honour.vue'),
                    },
                    {

                        path: '/about/us/history',
                        name: 'about.history',
                        meta: {
                            title: '发展历程',
                            tab: 4,
                            share_description:"打造数字经济时代最强大的珠宝玉石公司，在客户满意度、产业服务能力、伙伴成就感等方面追求极致"
                        },
                        component: () => import('@/views/about/components/us/History.vue'),
                    },
                ]
            },
            {

                path: '/about/company',
                name: 'about.company',
                meta: {
                    title: '分公司介绍'
                },
                component: () => import('@/views/about/Company.vue'),
            },
            {

                path: '/about/expert',
                name: 'about.expert',
                meta: {
                    title: '专家委员会'
                },
                component: () => import('@/views/about/Expert.vue'),
            },
            {

                path: '/about/commonweal',
                name: 'about.commonweal',
                meta: {
                    title: '公益事业'
                },
                component: () => import('@/views/about/Commonweal.vue'),
            },
            {

                path: '/about/purchase',
                name: 'about.purchase',
                meta: {
                    title: '如何购买'
                },
                component: () => import('@/views/about/Purchase.vue'),
            },
            {

                path: '/about/aftersale',
                name: 'about.aftersale',
                meta: {
                    title: '售后服务'
                },
                component: () => import('@/views/about/AfterSale.vue'),
            },
            {

                path: '/about/ensure',
                name: 'about.ensure',
                meta: {
                    title: '品质保障'
                },
                component: () => import('@/views/about/Ensure.vue'),
            },
            {

                path: '/about/follow',
                name: 'about.follow',
                meta: {
                    title: '关注我们'
                },
                component: () => import('@/views/about/Follow.vue'),
            },
            {

                path: '/about/contact',
                name: 'about.contact',
                meta: {
                    title: '联系我们'
                },
                component: () => import('@/views/about/Contact.vue'),
            },
            {
                path: '/about/promise',
                name: 'about.promise',
                meta: {
                    title: '保真承诺'
                },
                component: () => import('@/views/about/Promise.vue'),
            }
        ]
    },
    {
        path: '/privacy',
        name: 'privacy',
        meta: {
            title: '翡翠王朝用户协议和隐私政策'
        },
        component: () => import('@/views/Privacy.vue')
    },
    {
        path: '/UserAgreement',
        name: 'UserAgreement',
        meta: {
            title: '翡翠王朝用户协议'
        },
        component: () => import('@/views/UserAgreement.vue')
    },
    {
        path: '/PrivacyPolicy',
        name: 'PrivacyPolicy',
        meta: {
            title: '翡翠王朝用户隐私政策'
        },
        component: () => import('@/views/PrivacyPolicy.vue')
    },
    {
        path: '/safeguard',
        name: 'safeguard',
        meta: {
            title: '保障'
        },
        component: () => import('@/views/Safeguard.vue')
    },
    {
        path: '/trust',
        name: 'trust',
        meta: {
            title: '十三年品质保证·铸就信赖品牌'
        },
        component: () => import('@/views/Trust.vue')
    },
    {
        path: '/livePartner',
        name: 'livePartner',
        meta: {
            title: '合作伙伴招募',
            share_title: '翡翠王朝直播合作伙伴招募',
            share_description: '共襄盛举·合作共赢，翡翠王朝启动直播合作招募计划，快来零门槛开直播吧！',
        },
        component: () => import('@/views/LivePartner.vue')
    },
    {
        path: '/report',
        name: 'report',
        meta: {
            title: '媒体报道'
        },
        component: () => import('@/views/Report.vue')
    },
    {
        path: '/braceletMeasure',
        name: 'braceletMeasure',
        meta: {
            title: '手镯测量说明'
        },
        component: () => import('@/views/BraceletMeasure.vue')
    },
    {
        path: '/active',
        name: 'active',
        meta: {
            title: '母亲节',
            share_title: '趁现在 及时爱',
            share_description: '和妈妈说过这么多话，但最想说的都在这',
            share_image: 'https://res.jaadee.net/active/images/Lark20200509-163841.jpeg'
        },
        component: () => import('@/views/active/Mum.vue')
    },
    {
        path: '/identify',
        name: 'identify',
        meta: {
            title: '玉石鉴别服务',
            share_title: '玉石鉴别服务开创者 13年诚信经营',
            share_description: '严格品控•权威质检•假一赔十•7天自由退换',
            share_image: 'https://res.jaadee.net/uploads/upgrade/articleVideo/20200620/w7js40689u.jpg'
        },
        component: () => import('@/views/otherPage/identify.vue')
    },
    {
        path: '/famousAssemble',
        name: 'famousAssemble',
        meta: {
            title: '名家荟萃',
        },
        component: () => import('@/views/FamousAssemble.vue')
    },

    {
        path: '/famous',
        name: 'famous',
        meta: {
            title: '名家荟萃',
        },
        component: () => import('@/views/famous/Famous.vue')
    },
    {
        path: '/enterFamous',
        name: 'enterFamous',
        meta: {
            title: '名家荟萃',
        },
        component: () => import('@/views/famous/EnterFamous.vue')
    },
    {
        path: '/jadeBean',
        name: 'jadeBean',
        meta: {
            title: '翡翠豆获取攻略',
        },
        component: () => import('@/views/otherPage/jadeBean.vue')
    },
    // wallet
    {
        path: '/wallet/index',
        name: 'wallet.index',
        meta: {
            title: '我的钱包'
        },
        component: () => import('@/views/wallet/Index.vue')
    },
    {
        path: '/wallet/banks',
        name: 'wallet.banks',
        meta: {
            title: '银行卡列表'
        },
        component: () => import('@/views/wallet/BankList.vue')
    },
    {
        path: '/wallet/particulars',
        name: 'wallet.particulars',
        meta: {
            title: '钱包明细'
        },
        component: () => import('@/views/wallet/Particulars.vue')
    },
    {
        path: '/wallet/withdrawApply',
        name: 'wallet.withdrawApply',
        meta: {
            title: '申请提现'
        },
        component: () => import('@/views/wallet/WithdrawApply.vue')
    },
    {
        path: '/wallet/particularsDetail',
        name: 'wallet.particularsDetail',
        meta: {
            title: '钱包明细详情'
        },
        component: () => import('@/views/wallet/ParticularsDetail.vue')
    },
    {
        path: '/wallet/applyMoneyDetails',
        name: 'wallet.applyMoneyDetails',
        meta: {
            title: '申请提现详情'
        },
        component: () => import('@/views/wallet/ApplyMoneyDetails.vue')
    },
    {
        path: '/wallet/addBankCard',
        name: 'wallet.addBankCard',
        meta: {
            title: '添加银行卡'
        },
        component: () => import('@/views/wallet/AddBankCard.vue')
    },
    {
        path: '/wallet/withdrawAccount',
        name: 'wallet.withdrawAccount',
        meta: {
            title: '提现到卡'
        },
        component: () => import('@/views/wallet/WithdrawAccount.vue')
    },
    {
        path: '/wallet/applyAccountResult',
        name: 'wallet.applyAccountResult',
        meta: {
            title: '申请提现详情'
        },
        component: () => import('@/views/wallet/ApplyAccountResult.vue')
    },
    {
        path: '/wallet/transferAccounts',
        name: 'wallet.transferAccounts',
        meta: {
            title: '银行转账'
        },
        component: () => import('@/views/wallet/TransferAccounts.vue')
    },
    {
        path: '/mySet/Disclaimer',
        name: 'mySet.Disclaimer',
        meta: {
            title: '免责声明'
        },
        component: () => import('@/views/mySet/Disclaimer.vue')
    },
    {
        path: '/mySet/FeedBack',
        name: 'mySet.FeedBack',
        meta: {
            title: '意见反馈'
        },
        component: () => import('@/views/mySet/FeedBack.vue')
    }
]
